module.exports = __webpack_public_path__ + "img/ps.28f74430.svg";